import React from 'react'
import $ from 'jquery'
import BusinessEntity from './Subcomponents/BusinessEntity'
import EntityCount from './Subcomponents/EntityCount'

const BusinessEntities = (props) => {
    const sourceEntity = props.businessEntitiesSource
    const targetEntity = props.businessEntitiesTarget
    const allEntity = sourceEntity.concat(targetEntity)

    // $(document).ready(function(){
    //     $("div.entityListNew .entityList").each(function(){
    //         var mnIdr = $(this).attr('id');
    //         $('.'+mnIdr).slice(1).addClass("d-none")
    //     })
    // })
    

    return (
        <>
            <EntityCount
                sourceShortName={props.sourceShortName}
                targetShortName={props.targetShortName}
                instancesId={props.instancesId}
                sourceEntity={sourceEntity}
                targetEntity={targetEntity}
                allEntity={allEntity} 
                sourceId={props.sourceId}
                targetId={props.targetId}
            />
            <div className='scrollingContainer'>
                <div className='row p-10 entityListNew'>
                    <BusinessEntity
                        key={props.key}
                        sourceEntity={sourceEntity}
                        targetEntity={targetEntity}
                    />
                </div>
            </div>
        </>
    )
    
}

export default BusinessEntities